<style lang='scss' scoped>
// 下拉列表动画
@keyframes dropdownFade {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.syslist {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    white-space: nowrap;
    
    // 深色赛博朋克渐变背景
    background: linear-gradient(-45deg, #0a0e27, #1a1f3a, #0d1b2a);
    border: 1px solid rgba(0, 212, 255, 0.3);
    border-radius: 12px;
    box-shadow: 
        0 10px 40px rgba(0, 0, 0, 0.5),
        0 0 20px rgba(0, 212, 255, 0.2),
        inset 0 0 30px rgba(0, 212, 255, 0.05);
    
    color: #fff;
    font-size: 13px;
    min-width: 560px;
    overflow: hidden;
    animation: dropdownFade 0.3s ease-out;
    
    // 顶部装饰线
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, transparent, #00d4ff, transparent);
    }
    
    .syslist-search {
        margin: 20px;
        
        ::v-deep .ivu-input {
            background: rgba(0, 0, 0, 0.4);
            border: 1px solid rgba(0, 212, 255, 0.3);
            color: #fff;
            border-radius: 8px;
            
            &::placeholder {
                color: rgba(255, 255, 255, 0.4);
            }
            
            &:focus {
                border-color: #00d4ff;
                box-shadow: 0 0 15px rgba(0, 212, 255, 0.4);
                background: rgba(0, 0, 0, 0.6);
            }
        }
    }
    
    .syslist-content {
        padding: 12px 20px;
        height: 300px;
        overflow: auto;
        
        // 滚动条样式
        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-track {
            background: rgba(0, 0, 0, 0.2);
            border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(0, 212, 255, 0.3);
            border-radius: 3px;
            &:hover {
                background: rgba(0, 212, 255, 0.6);
            }
        }
    }
    
    div {
        display: table-row;
        line-height: 40px;
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 6px;
        margin: 2px 0;
        
        &:hover {
            color: #00d4ff;
            background: rgba(0, 212, 255, 0.15);
            box-shadow: inset 0 0 10px rgba(0, 212, 255, 0.2);
            
            span {
                text-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
            }
        }
    }
    
    span {
        display: table-cell;
        min-width: 100px;
        padding: 0 10px;
        transition: all 0.3s ease;
    }
    
    footer {
        text-align: center;
        padding: 60px;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.5);
    }
}
</style>


<template>
	<div class="syslist" @click.stop>
		<vInput
			v-model="searchName"
			class="syslist-search"
			:placeholder="$t('global.nav.shorttip')"
			@on-change="getSysList()"
			@on-enter="getSysList()"
		></vInput>
		<aside class="syslist-content" v-scroll-load-vview="loadingList">
			<template v-if="syslist.length>0">
				<div v-for="item in syslist" @click.stop="handleUserInfo(item)">
					<span>id:{{item.id}}</span>
					<span>{{$t('global.common.organization')}}:{{item.name}}</span>
					<span>code:{{item.code}}</span>
				</div>
			</template>
			<footer v-else>{{$t('global.common.nodata')}}</footer>
		</aside>
	</div>
</template>

<script>
import { HttpSystemList } from '../../../../service/base';
import { mapActions, mapMutations } from 'vuex';
export default {

	data() {
		return {
			syslist: [],
			page: 1,
			searchName: '',
		};
	},
	created() {
		this.getSysList();
	},
	methods: {
		...mapActions(['actionInitBaseData']),
		...mapMutations(['setOrganization']),
		handleUserInfo(item) {
			sessionStorage.removeAll('', true);
			localStorage.removeAll('', true);
			localStorage.setItem('TEMP_CHEAR_SESSION', true, { scope: '', version: '' });
			localStorage.removeItem('TEMP_CHEAR_SESSION');
			this.$nextTick(() => {
				this.$parent.visible = false;
                // this.setOrganization({ id: item.id, name: item.name, logoUrl: item.logo || '', attach: { ...item } });
                this.setOrganization({
                    ...item,
                    logoUrl: item.logo
                });
				this.actionInitBaseData({ updateInit: true });
			})
		},
		getSysList(loading) {
			if (!loading) this.page = 1;
			return HttpSystemList({
				rows: 20,
				page: this.page,
				sidx: 'id',
				sord: 'desc',
				search: {
					CN_name: this.searchName,
					EQ_status: 1
				}
			}).then((res) => {
				const data = res.data.content || [];
				this.syslist = loading ? [...this.syslist, ...data] : data;
			}, () => {

			});
		},
		loadingList() {
			this.page += 1;
			this.getSysList(true)
		},
	},


};
</script>
